import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global fetch interceptor to automatically prepend REACT_APP_API_URL and log all requests
const originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  const baseUrl = process.env.REACT_APP_API_URL || '';
  let targetUrl = url;

  if (typeof url === 'string') {
    // Prepend API URL if it's a relative path and doesn't already start with http/https
    if (url.startsWith('/') && !url.startsWith('http') && baseUrl) {
      targetUrl = `${baseUrl.replace(/\/$/, '')}${url}`;
    }
    console.log(`[API Request] ${options.method || 'GET'} ${targetUrl}`);
  }

  return originalFetch(targetUrl, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
